import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { ColDef, ColumnApi, FocusService, GridApi, GridOptions, GridReadyEvent, RowClickedEvent } from 'ag-grid-community';
import * as moment from 'moment';
import { formatCurrency, Location } from '@angular/common';
import { AmountInputCellRenderer } from 'src/app/common/amount-input-cell-renderer.component';
import { DatepickerCellRenderer } from 'src/app/common/datepicker-cell-renderer.component';
import { InputCellRenderer } from 'src/app/common/input-cell-renderer.component';
import { SelectCellRenderer } from 'src/app/common/select-cell-renderer.component';
import { ExchangeRateService } from '../exchange-rate-service';
import { MenusService } from 'src/app/_services/menu.service';
import { AlertService } from 'src/app/_services/alert.service';
import Swal from 'sweetalert2';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { AmountPercentInputCellRenderer } from 'src/app/common/amount-percent-input-cell-renderer.component';
import { MarkupInputCellRenderer } from 'src/app/common/markup-input-cell-renderer.component copy';
import { log } from 'console';
import { data, param } from 'jquery';
import { ExchangeRateInput } from 'src/app/common/exchange-rate-input-cell';
import { NgSelectComponent } from '@ng-select/ng-select';
import { environment } from 'src/environments/environment';
const {defaultCurrency} = environment;
export class TypeDataTable {
  "symbol": string;
  "fromCurrency": string;
  "toCurrency": string;
  "currencyName": string;
  "country": string;
  "exchangeRate": number;
  "offeredRate": number;
  "fromAmount": number;
  "toAmount": number;
  "markUp": number;
  "markUpPercentage": number;
  "markUpType": string;
  "effectiveDate": string;
  "chargesType": string;
  "isAmountDisabled": Boolean;
  "isMarkUpAmountDisabled": Boolean;
  "isAmountPercentDisabled": Boolean;
  "showEditButton": Boolean;
  "isDatepickerDisabled": Boolean;
  "isSelectDisabled": Boolean;

}

@Component({
  selector: 'app-exchange-rate-edit',
  templateUrl: './exchange-rate-edit.component.html',
  styleUrls: ['./exchange-rate-edit.component.scss']

})

export class ExchangeRateEditComponent implements OnInit {

  @ViewChild('openReviewSlab') private reviewExchangeModal: ModalComponent;
  
  modalExchangeReview: ModalConfig;
  editExchangeSlabForm: FormGroup;
  submitted: boolean = false;
  showDataTable: boolean = false;
  public gridApi: GridApi;
  public gridApiSlab: GridApi<any>;
  public gridApiDirect: GridApi;
  finalExchangeData: any[];
  selectedCurrency: any;
  selectedCurrencyName : any;
  selectedCurrencySymbol : any;
  selectedCountry: any;
  savedSlabData: any[];
  public permissions: any;
  showSavedDataTable: boolean = false;
  showType: boolean = false;
  selectedDirect: boolean = false;
  selectedSlab: boolean = false;
  directData: any[];
  slabData: any[];
  saveButtonVisible: boolean = false;
  directTypeData: TypeDataTable;
  slabTypeData: TypeDataTable;
  selectedType: any;
  oldSlabs: any[];
  newSlabs: any[];
  showNewSlab: boolean = false;
  showOldSlab: boolean = false;
  slabRemarks: any;
  uuid: string;
  cloneData: any[];
  cloneFinalData: any[];
  cloneStatus: string = "";
  addSlabPermission: boolean = false;
  selectedClone: boolean = false;
  testData: ColDef[];
  selectedCloneType: string = "";
  public savedData: any[];
  showAddDirectSlabButton: boolean = false;
  maxBalance : any;
  maxBalanceField : boolean = false;


  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 140,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public columnDefsSaved: ColDef[] = [

    { field: 'toCurrencySymbol', headerName: 'Symbol', editable: false, lockVisible: true },
    { field: 'toCurrencyName', headerName: 'Currency Name', editable: false, lockVisible: true },
    {
      field: "selectedCountry", headerName: 'Country', editable: false, lockVisible: true, valueGetter: (params) => {
        return this.selectedCountry;
      }
    },
    { field: 'exchangeRate', headerName: 'Current Rate', editable: false, lockVisible: true },
    { field: 'offeredRate', headerName: 'Offered Rate', lockVisible: true,},
    { field: 'fromAmount', headerName: 'From Amount', editable: false, lockVisible: true },
    { field: 'toAmount', headerName: 'To Amount', editable: false, lockVisible: true },
    { field: 'markUpAmount', headerName: 'Mark Up Amount', editable: false, lockVisible: true },
    { field: 'markUpPercentage', headerName: 'Mark Up Percentage', editable: false, lockVisible: true, },
    { field: 'markUpType', headerName: 'Mark Up Type', editable: false, lockVisible: true, },
    { field: 'effectiveDate', headerName: 'Effective Update Date', editable: false, lockVisible: true },
    { field: 'chargesType', headerName: 'Charges Type', editable: false, lockVisible: true },
    { field: 'chargesStatus', headerName: 'Status', editable: false, lockVisible: true },
    { field: 'createdBy', headerName: 'Created By', editable: false, lockVisible: true },
    { field: 'createDate', headerName: 'Created On', editable: false, lockVisible: true },
    { field: 'approvedBy', headerName: 'Approved By', editable: false, lockVisible: true },
    { field: 'approvedDate', headerName: 'Approved On', editable: false, lockVisible: true },

  ];


  public columnDefs: ColDef[] = [
    {
      field: 'symbol', headerName: 'Symbol', editable: false, lockVisible: true,cellStyle: {fontSize: '1rem'}
    },
    { field: 'currencyName', headerName: 'Currency Name', editable: false, lockVisible: true ,cellStyle: {fontSize: '1rem'}},
    { field: 'country', headerName: 'Country', editable: false, lockVisible: true ,cellStyle: {fontSize: '1rem'}},
    {
      field: 'exchangeRate', headerName: 'Current Rate',cellStyle: {fontSize: '1rem'}, cellRenderer: ExchangeRateInput, cellRendererParams: ['exchangeRate'], lockVisible: true, onCellValueChanged: (params: any) => {
        const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
        if (rowNode) {
          rowNode.setDataValue('offeredRate', Number(params.newValue));
          rowNode.setDataValue('markUpPercentage', 0);
          rowNode.setDataValue('markUp', 0);
          rowNode.setDataValue('exchangeRate', Number(params.newValue));
        }
      }
    },
    { field: 'offeredRate', headerName: 'Offered Rate',editable: false,lockVisible: true,cellStyle: {fontSize: '1rem'}},
    { field: 'fromAmount', headerName: 'From Amount', editable: false, lockVisible: true,cellStyle: {fontSize: '1rem'} },
    {
      field: 'toAmount', headerName: 'To Amount', lockVisible: true, resizable: true, cellRenderer: AmountInputCellRenderer, onCellValueChanged: (params: any) => {
        if (Number(params.newValue) <= (Number(this.maxBalance) - 1)) {
          const nextRowVal = this.gridApiSlab.getDisplayedRowAtIndex(params.node.rowIndex + 1)!.data;
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex + 1).toString());
          if (rowNode) {
            this.slabData[params.node.rowIndex + 1].fromAmount = 1 + Number(params.newValue)
            const newData = { ...rowNode.data, fromAmount: 1 + Number(params.newValue) };
            rowNode.setData(newData);
            console.log(rowNode);
            console.log(newData);
             this.gridApiSlab.refreshCells({ rowNodes: [newData], force: true });
            console.log(this.gridApiSlab.getRowNode((params.node.rowIndex + 1).toString()));
          }
        }
      }
    },
    {
      field: 'markUp', headerName: 'Mark Up Amount',cellStyle: {fontSize: '1rem'}, cellRenderer: MarkupInputCellRenderer, lockVisible: true, onCellValueChanged: (params: any) => {
        const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
        let percentage = 0;
        console.log("Active amount "+this.slabData[params.node.rowIndex].isMarkUpAmountDisabled);
        
        if (rowNode && this.slabData[params.node.rowIndex].markUpType=="FLAT") {
          console.log(parseFloat(params.data.exchangeRate));
          if (parseFloat(params.data.exchangeRate) == 0 || params.data.exchangeRate == "NaN") {
            this.alertService.toastWarringMessageAlertWithMessage("Please enter the current rate");
            this.slabData[params.node.rowIndex].offeredRate = 0;
          } else if (params.newValue == "NaN" || params.newValue == "") {
            this.slabData[params.node.rowIndex].offeredRate = 0;
            this.slabData[params.node.rowIndex].markUpPercentage = 0;
          } else if (Number(params.newValue) >= Number(params.data.exchangeRate)) {
            this.alertService.toastWarringMessageAlertWithMessage("MarkUp Amount cannot be greater than or equal to Current Rate")
            this.slabData[params.node.rowIndex].offeredRate = params.data.exchangeRate;
            this.slabData[params.node.rowIndex].markUpPercentage = 0;
            this.slabData[params.node.rowIndex].markUp = 0;
          }else {
            this.slabData[params.node.rowIndex].offeredRate = Number(parseFloat(params.data.exchangeRate) - parseFloat(params.newValue)).toFixed(6);
            percentage = (this.slabData[params.node.rowIndex].markUp / this.slabData[params.node.rowIndex].offeredRate) * 100
            this.slabData[params.node.rowIndex].markUpPercentage = percentage.toFixed(6);
          }
          rowNode.setDataValue('offeredRate', this.slabData[params.node.rowIndex].offeredRate);
          rowNode.setDataValue('markUpPercentage', this.slabData[params.node.rowIndex].markUpPercentage);
          rowNode.setDataValue('markUp', this.slabData[params.node.rowIndex].markUp);
        }
      }
    },
    {
      field: 'markUpPercentage', headerName: 'Mark Up Percentage',cellStyle: {fontSize: '1rem'}, cellRenderer: AmountPercentInputCellRenderer, lockVisible: true, onCellValueChanged: (params: any) => {
        const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
        let markUpAmount = 0;
        console.log("active percentage "+this.slabData[params.node.rowIndex].isAmountPercentDisabled);
        
        if (rowNode && this.slabData[params.node.rowIndex].markUpType=="PERCENTAGE") {
          const finalMarkUpPercentage = Number((parseFloat(params.data.exchangeRate) / (100+parseFloat(params.data.markUpPercentage)))*100);
          console.log(finalMarkUpPercentage);
          if (isNaN(finalMarkUpPercentage)) {
            console.log("Setting NaN data");
            this.slabData[params.node.rowIndex].offeredRate = 0;
            this.slabData[params.node.rowIndex].markUp = 0;
            this.slabData[params.node.rowIndex].markUpPercentage = params.data.markUpPercentage;
          } else if (parseFloat(params.data.exchangeRate) == 0 || params.data.exchangeRate == "NaN") {
            this.alertService.toastWarringMessageAlertWithMessage("Please enter the current rate");
            this.slabData[params.node.rowIndex].offeredRate = 0;
            this.slabData[params.node.rowIndex].markUp = 0;
            this.slabData[params.node.rowIndex].markUpPercentage = params.data.markUpPercentage;
          } else if (Number(params.newValue) > 100) {
            this.alertService.toastWarringMessageAlertWithMessage("MarkUp Percentage cannot be greater than 100 Percentage")
            this.slabData[params.node.rowIndex].offeredRate = params.data.exchangeRate;
            this.slabData[params.node.rowIndex].markUpPercentage = 0;
            this.slabData[params.node.rowIndex].markUp = 0;
          }else {
            this.slabData[params.node.rowIndex].offeredRate = finalMarkUpPercentage.toFixed(6);
            console.log( Number((parseFloat(params.data.exchangeRate))));
            console.log(this.slabData[params.node.rowIndex].offeredRate);
            markUpAmount =  Number((parseFloat(params.data.exchangeRate))) - this.slabData[params.node.rowIndex].offeredRate;
            console.log(markUpAmount);
            this.slabData[params.node.rowIndex].markUp = markUpAmount.toFixed(6);
            this.slabData[params.node.rowIndex].markUpPercentage = params.data.markUpPercentage;
          }
          rowNode.setDataValue('offeredRate', this.slabData[params.node.rowIndex].offeredRate);
          rowNode.setDataValue('markUp', this.slabData[params.node.rowIndex].markUp);
          rowNode.setDataValue('markUpPercentage', this.slabData[params.node.rowIndex].markUpPercentage);
        }
      }
    },
    {
      field: 'markUpType', lockVisible: true, headerName: 'Select Markup Type',cellStyle: {fontSize: '1rem'}, cellRenderer: SelectCellRenderer, cellEditorParams: {
        options: [
          { value: 'FLAT', label: 'FLAT' },
          { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        ]
      }, onCellValueChanged: (params: any) => {
        const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
        console.log(rowNode);
        if (rowNode) {
          console.log(params.newValue);
          console.log(params.data);
          console.log(this.slabData[params.node.rowIndex]);

          if(params.newValue == "FLAT"){
            this.slabData[params.node.rowIndex].isAmountPercentDisabled = true;
            this.slabData[params.node.rowIndex].isMarkUpAmountDisabled = false;
          }else if(params.newValue == "PERCENTAGE"){
            this.slabData[params.node.rowIndex].isMarkUpAmountDisabled = true;
            this.slabData[params.node.rowIndex].isAmountPercentDisabled = false;
          }

          // this.slabData[params.node.rowIndex]['isMarkUpAmountDisabled'] = params.newValue === 'FLAT' ? false : true;
          // this.slabData[params.node.rowIndex]['isAmountPercentDisabled'] = params.newValue === 'PERCENTAGE' ? false : true;

          console.log(this.slabData[params.node.rowIndex].markUpType);
          console.log(this.slabData[params.node.rowIndex].isAmountPercentDisabled);
          console.log(this.slabData[params.node.rowIndex].isMarkUpAmountDisabled);
          this.slabData[params.node.rowIndex].markUpType = params.newValue;
          this.slabData[params.node.rowIndex].markUp = 0;
          this.slabData[params.node.rowIndex].markUpPercentage = 0;
          this.slabData[params.node.rowIndex].offeredRate = params.data.exchangeRate;
          this.slabData[params.node.rowIndex].exchangeRate = params.data.exchangeRate;
          this.gridApiSlab.setRowData(this.slabData);
          console.log(this.slabData[params.node.rowIndex]);

        }
      }
    },
    {
      field: 'effectiveDate', headerName: 'Effective Update Date',cellStyle: {fontSize: '1rem'}, lockVisible: true, cellRenderer: DatepickerCellRenderer, onCellValueChanged: (params: any) => {
        this.slabData.map((_: any, i: number) => {
          _.effectiveDate = moment(params.newValue, ['YYYY-MM-DD HH:mm']).format("MM-DD-YYYY HH:mm");
        })
        this.gridApiSlab.setRowData(this.slabData);
      }
    },

  ];

  public columnDefDirect: ColDef[] = [
    {
      field: 'symbol', headerName: 'Symbol', editable: false, lockVisible: true,cellStyle: {fontSize: '1rem'}
    },
    { field: 'currencyName', headerName: 'Currency Name', editable: false, lockVisible: true ,cellStyle: {fontSize: '1rem'}},
    { field: 'country', headerName: 'Country', editable: false, lockVisible: true,cellStyle: {fontSize: '1rem'} },
    {
      field: 'exchangeRate', headerName: 'Current Rate',cellStyle: {fontSize: '1rem'}, cellRenderer: ExchangeRateInput, cellRendererParams: ['exchangeRate'], lockVisible: true, onCellValueChanged: (params: any) => {
        const rowNode = this.gridApiDirect.getRowNode((params.node.rowIndex).toString());
        if (rowNode) {
          rowNode.setDataValue('offeredRate', params.newValue);
          rowNode.setDataValue('markUpPercentage', 0);
          rowNode.setDataValue('markUp', 0);
        }
      }
    },
    { field: 'offeredRate', headerName: 'Offered Rate',editable:false,  lockVisible: true ,cellStyle: {fontSize: '1rem'}},
    { field: 'fromAmount', headerName: 'From Amount', editable: false, lockVisible: true ,cellStyle: {fontSize: '1rem'}},
    {
      field: 'toAmount', headerName: 'To Amount', lockVisible: true, resizable: true,cellStyle: {fontSize: '1rem'}, cellRenderer: AmountInputCellRenderer, onCellValueChanged: (params: any) => {
        if (Number(params.newValue) <= (Number(this.maxBalance) - 1)) {
          const nextRowVal = this.gridApiDirect.getDisplayedRowAtIndex(params.node.rowIndex + 1)!.data;
          const rowNode = this.gridApiDirect.getRowNode((params.node.rowIndex + 1).toString());
          if (rowNode) {
            this.directData[params.node.rowIndex + 1].fromAmount = Number(params.data.fromAmount) + Number(params.newValue)
            const newData = { ...rowNode.data, fromAmount: Number(params.data.fromAmount) + Number(params.newValue) };
            rowNode.setData(newData);
            this.gridApiDirect.refreshCells({ rowNodes: [rowNode], force: true });
          }
        }
      }
    },
    {
      field: 'markUp', headerName: 'Mark Up Amount', cellRenderer: MarkupInputCellRenderer,cellStyle: {fontSize: '1rem'}, lockVisible: true, onCellValueChanged: (params: any) => {
        const rowNode = this.gridApiDirect.getRowNode((params.node.rowIndex).toString());
        let percentage = 0;
        console.log(params.newValue);
        if (rowNode) {
          console.log(parseFloat(params.data.exchangeRate));
          if (parseFloat(params.data.exchangeRate) == 0 || params.data.exchangeRate == "NaN") {
            this.alertService.toastWarringMessageAlertWithMessage("Please enter the current rate");
            this.directData[params.node.rowIndex].offeredRate = 0;
          } else if (params.newValue == "NaN" || params.newValue=="") {
            this.directData[params.node.rowIndex].offeredRate = 0;
            this.directData[params.node.rowIndex].markUpPercentage = 0;
          }  else if (Number(params.newValue) >= Number(params.data.exchangeRate)) {
            this.alertService.toastWarringMessageAlertWithMessage("MarkUp Amount cannot be greater than or equal to Current Rate")
            this.directData[params.node.rowIndex].offeredRate = params.data.exchangeRate;
            this.directData[params.node.rowIndex].markUpPercentage = 0;
            this.directData[params.node.rowIndex].markUp = 0;
          }else {
            this.directData[params.node.rowIndex].offeredRate = Number(parseFloat(params.data.exchangeRate) - parseFloat(params.newValue)).toFixed(6);
            percentage = (this.directData[params.node.rowIndex].markUp / this.directData[params.node.rowIndex].offeredRate) * 100
            this.directData[params.node.rowIndex].markUpPercentage = percentage.toFixed(6);
          }
          rowNode.setDataValue('offeredRate', this.directData[params.node.rowIndex].offeredRate);
          rowNode.setDataValue('markUpPercentage', this.directData[params.node.rowIndex].markUpPercentage);
          rowNode.setDataValue('markUp', this.directData[params.node.rowIndex].markUp);
          // rowNode.setDataValue('markUpPercentage', percentage);
        }
      }
    },
    {
      field: 'markUpPercentage', headerName: 'Mark Up Percentage',cellStyle: {fontSize: '1rem'}, cellRenderer: AmountPercentInputCellRenderer, lockVisible: true, onCellValueChanged: (params: any) => {
        const rowNode = this.gridApiDirect.getRowNode((params.node.rowIndex).toString());
        let markUp = 0;
        if (rowNode) {
          const finalMarkUpPercentage = Number((parseFloat(params.data.exchangeRate) / (100+parseFloat(params.data.markUpPercentage)))*100);
          console.log(finalMarkUpPercentage);
          if (isNaN(finalMarkUpPercentage)) {
            this.directData[params.node.rowIndex].offeredRate = params.data.exchangeRate;
            this.directData[params.node.rowIndex].markUp = 0;
          } else if (parseFloat(params.data.exchangeRate) == 0 || params.data.exchangeRate == "NaN") {
            this.alertService.toastWarringMessageAlertWithMessage("Please enter the current rate");
            this.directData[params.node.rowIndex].offeredRate = 0;
            this.directData[params.node.rowIndex].markUp = 0;
          } else if (Number(params.newValue) > 100) {
            this.alertService.toastWarringMessageAlertWithMessage("MarkUp Percentage cannot be greater than 100 Percentage")
            this.directData[params.node.rowIndex].offeredRate = params.data.exchangeRate;
            this.directData[params.node.rowIndex].markUpPercentage = 0;
            this.directData[params.node.rowIndex].markUp = 0;
          }else {
            this.directData[params.node.rowIndex].offeredRate = finalMarkUpPercentage.toFixed(6);
            markUp = this.directData[params.node.rowIndex].exchangeRate - this.directData[params.node.rowIndex].offeredRate;
            console.log(markUp);
            this.directData[params.node.rowIndex].markUp = markUp.toFixed(6);
          }
          rowNode.setDataValue('offeredRate', this.directData[params.node.rowIndex].offeredRate);
          rowNode.setDataValue('markUp', this.directData[params.node.rowIndex].markUp);
          rowNode.setDataValue('markUpPercentage', this.directData[params.node.rowIndex].markUpPercentage);
          //  rowNode.setDataValue('markUp',markUp);
        }
      }
    },
    {
      field: 'markUpType', lockVisible: true, headerName: 'Select Markup Type',cellStyle: {fontSize: '1rem'}, cellRenderer: SelectCellRenderer, cellEditorParams: {
        options: [
          { value: 'FLAT', label: 'FLAT' },
          { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        ]
      }, onCellValueChanged: (params: any) => {
        const rowNode = this.gridApiDirect.getRowNode((params.node.rowIndex).toString());
        if (rowNode) {

          if(params.newValue == "FLAT"){
            this.directData[params.node.rowIndex].isAmountPercentDisabled = true;
            this.directData[params.node.rowIndex].isMarkUpAmountDisabled = false;
          }else if(params.newValue == "PERCENTAGE"){
            this.directData[params.node.rowIndex].isMarkUpAmountDisabled = true;
            this.directData[params.node.rowIndex].isAmountPercentDisabled = false;
          }

          // this.slabData[params.node.rowIndex]['isMarkUpAmountDisabled'] = params.newValue === 'FLAT' ? false : true;
          // this.slabData[params.node.rowIndex]['isAmountPercentDisabled'] = params.newValue === 'PERCENTAGE' ? false : true;

          console.log(this.directData[params.node.rowIndex].markUpType);
          console.log(this.directData[params.node.rowIndex].isAmountPercentDisabled);
          console.log(this.directData[params.node.rowIndex].isMarkUpAmountDisabled);
          this.directData[params.node.rowIndex].markUpType = params.newValue;
          this.directData[params.node.rowIndex].markUp = 0;
          this.directData[params.node.rowIndex].markUpPercentage = 0;
          this.directData[params.node.rowIndex].offeredRate = params.data.exchangeRate;
          this.directData[params.node.rowIndex].exchangeRate = params.data.exchangeRate;
          this.gridApiSlab.setRowData(this.directData);
          console.log(this.directData[params.node.rowIndex]);

        }
      }
    },
    {
      field: 'effectiveDate', headerName: 'Effective Update Date',cellStyle: {fontSize: '1rem'}, lockVisible: true, cellRenderer: DatepickerCellRenderer, onCellValueChanged: (params: any) => {
        this.directData.map((_: any, i: number) => {
          _.effectiveDate = moment(params.newValue, ['YYYY-MM-DD HH:mm']).format("MM-DD-YYYY HH:mm");
        })
        this.gridApiSlab.setRowData(this.directData);
      }
    },

  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumnSaved: ColDef[] = [...(this.columnDefsSaved.filter((col) => !col?.hide))];
  tableSelectedColumnDirect: ColDef[] = [...(this.columnDefDirect.filter((col) => !col?.hide))];

  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private exchangeService: ExchangeRateService, private menuService: MenusService, private location: Location, private alertService: AlertService, private router: Router) { }


  ngOnDestroy(){
    console.log("Component Exchange Destoryed");
    if(this.reviewExchangeModal.isOpen()){
      this.reviewExchangeModal.close();
    } 
  }

  ngOnInit(): void {

    this.modalExchangeReview = {
      modalTitle: "Exchange Rate Slab",
      modalSize: 'xl',


      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.finalExchangeData = [];
    const path = "/exchangeRates";
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions);
    if(this.permissions.includes('Approve')){
      this.maxBalanceField = true;
    }
    this.selectedCountry = this.route.snapshot.queryParamMap.get("country");
    this.selectedCurrency = this.route.snapshot.queryParamMap.get("currency");
    this.selectedCurrencyName = this.route.snapshot.queryParamMap.get("currencyName");
    this.maxBalance = this.route.snapshot.queryParamMap.get("balance");
    this.selectedCurrencySymbol = this.route.snapshot.queryParamMap.get("symbol");
    console.log(this.selectedCurrency);
    console.log(this.selectedCountry);
    console.log(this.selectedCurrencyName);
    // this.maxBalance = "1212";
    console.log(this.maxBalance);
    console.log(this.selectedCurrencySymbol);
    
    this.editExchangeSlabForm = this.formBuilder.group({
      country: ['', Validators.required],
      type: ['', Validators.required]
      
    })

    this.exchangeService.getExchangeSlabByCurrency(this.selectedCurrency).subscribe((response: any) => {
      console.log(response);
      if (response.response.data.length == 0) {
        this.showSavedDataTable = false;
      } else {
        this.showSavedDataTable = true;
      }
      this.savedSlabData = response.response.data;
    })
  }

  addExchangeSlabs() {
    console.log("final");
    console.log(this.selectedCloneType);
    console.log(this.selectedType);
    this.showType =false;
    console.log(this.selectedCloneType);
    if (this.selectedCloneType == "DIRECT"||this.selectedType=="DIRECT") {
      this.finalExchangeData = this.directData;

    } else if (this.selectedCloneType == "SLAB"||this.selectedType=="SLAB") {
      this.finalExchangeData = this.slabData;
    }

    this.finalExchangeData = JSON.parse(JSON.stringify(this.finalExchangeData));
    this.finalExchangeData.map((_: any) => {
      if(_.markUpType == "PERCENTAGE"){
        _.markUp = _.markUpPercentage
      }

      // if (_.markUp == "0") {
      //   _.markUp = (_.markUpPercentage * _.exchangeRate) / 100;
      // }
      // console.log("selected type"+ _);
      // _.chargesType=this.selectedCloneType?this.selectedCloneType: this.selectedType;
      delete _.isAmountDisabled;
      delete _.symbol;
      delete _.country;
      delete _.currencyName;
      delete _.offeredRate;
      delete _.markUpPercentage;
      delete _.isAmountPercentDisabled;
      delete _.isMarkUpAmountDisabled;
    })
    console.log(this.finalExchangeData);
    this.exchangeService.addExchangeRateSlab(this.finalExchangeData).subscribe((response: any) => {
      console.log(response);
      if (response.response.status == 200) {
        Swal.fire('Exchange rate saved Successfully', '', 'success').then((result)=>{
          if (result.isConfirmed) {
            this.router.navigate(['/exchangeRates']);
          }
        })
        // this.exchangeService.getExchangeSlabByCurrency(this.selectedCurrency).subscribe((response: any) => {
        //   console.log(response);
        //   if (response.response.data.length == 0) {
        //     this.showSavedDataTable = false;
           
        //   } else {
        //     this.showSavedDataTable = true;
        //     this.savedSlabData = response.response.data;
        //     this.selectedType = "";
        //     this.directData = [];
        //     this.slabData = [];
        //     this.selectedDirect = false;
        //     this.selectedSlab = false;
        //     this.saveButtonVisible = false;

        //   }
        // })
        
      }
      else {
        Swal.fire(response.response.message, '', 'error');
      }
    });

  }




  editExchangeSlab(data: any) {

  }

  countryChange(selectedCountry: any) {

  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api

  }

  onGridReadySlab(params: GridReadyEvent<any>) {
    this.gridApiSlab = params.api
    this.gridApiDirect = params.api

  }
  editMaxAmount(){
    this.maxBalanceField = false;
    this.saveButtonVisible = false;
    this.selectedDirect = false;
    this.directData = [];
    this.selectedSlab = false;
    this.slabData = [];
    this.showType = false;
  }

  addSlab() {
    this.maxBalanceField = true;
    this.saveButtonVisible = false;
    this.selectedDirect = false;
    this.directData = [];
    this.selectedSlab = false;
    this.slabData = [];
    console.log(this.maxBalance);
    if(this.maxBalance == ""){
      this.alertService.errorAlertWithMessage("Please enter max amount");
      this.maxBalanceField = false;
      return;
    }

    if(Number(this.maxBalance) <=1){
      this.alertService.errorAlertWithMessage("Max Amount cannot be less than equal to 1");
      this.maxBalanceField = false;
      return;
    }
    
    if (this.savedSlabData.length == 0) {
      this.showType = true;
    } else {
      for (let i: number = 0; i < this.savedSlabData.length; i++) {
        if (this.savedSlabData[i].chargesStatus == "PENDING") {
          this.showType = false;
          this.alertService.errorAlertWithMessage("You cannot add slabs, because previous slabs are in pending state");
          return;
        } else {
          this.showType = true;
        }
      }
    }

  }


  typeSelect(type: any) {
    this.selectedType = type;
    console.log(type);
    this.directData = [];
    this.slabData = [];
    this.selectedDirect = false;
    this.selectedSlab = false;
    this.saveButtonVisible = false;
    if (type == "DIRECT") {
      this.saveButtonVisible = true;
      this.selectedDirect = true;
      this.directTypeData = new TypeDataTable;
      this.directTypeData.symbol = this.selectedCurrencySymbol;
      this.directTypeData.currencyName = this.selectedCurrencyName;
      this.directTypeData.country = this.selectedCountry;
      this.directTypeData.fromCurrency = defaultCurrency;
      this.directTypeData.toCurrency = this.selectedCurrency;
      this.directTypeData.chargesType = this.selectedType;
      this.directTypeData.exchangeRate = 0.0;
      this.directTypeData.offeredRate = 0.0;
      this.directTypeData.fromAmount = 1;
      this.directTypeData.toAmount = Number(this.maxBalance);
      this.directTypeData.markUp = 0;
      this.directTypeData.markUpType = "PERCENTAGE";
      this.directTypeData.markUpPercentage = 0;
      this.directTypeData.isAmountDisabled = true;
      this.directTypeData.isMarkUpAmountDisabled = true;
      this.directTypeData.isAmountPercentDisabled = false;
      this.directTypeData.effectiveDate = moment().format("MM-DD-YYYY HH:mm");
      this.directData.push(this.directTypeData);
      // this.gridApiDirect.setRowData(this.directData);
      console.log(this.directData);
    } else if (type == "SLAB") {
      this.saveButtonVisible = true;
      this.selectedSlab = true;
      this.slabTypeData = new TypeDataTable;
      this.slabTypeData.symbol = this.selectedCurrencySymbol;
      this.slabTypeData.currencyName = this.selectedCurrencyName;
      this.slabTypeData.country = this.selectedCountry;
      this.slabTypeData.fromCurrency = defaultCurrency;
      this.slabTypeData.toCurrency = this.selectedCurrency;
      this.slabTypeData.chargesType = this.selectedType;
      this.slabTypeData.exchangeRate = 0.0;
      this.slabTypeData.offeredRate = 0.0;
      this.slabTypeData.fromAmount = 1;
      this.slabTypeData.toAmount = Number(this.maxBalance);
      this.slabTypeData.markUp = 0;
      this.slabTypeData.markUpType = "PERCENTAGE";
      this.slabTypeData.markUpPercentage = 0;
      this.slabTypeData.isAmountDisabled = true;
      this.slabTypeData.isMarkUpAmountDisabled = true;
      this.slabTypeData.isAmountPercentDisabled = false;
      this.slabTypeData.effectiveDate = moment().format("MM-DD-YYYY HH:mm");
      this.slabData.push(this.slabTypeData);
      // this.gridApiSlab.setRowData(this.slabData);
    }

  }


  clearTable(type: any) {
    console.log("called " + type);

    if (type == "DIRECT") {
      console.log("Direct");
      this.directData = [];
      const newRow = { symbol: this.selectedCurrencySymbol, currencyName: this.selectedCurrencyName, country: this.selectedCountry, exchangeRate: 0.0, offeredRate: 0.0, fromAmount: 1, toAmount: Number(this.maxBalance), markUp: 0.0, markUpType: "PERCENTAGE", markUpPercentage: 0, effectiveDate: moment().format("MM-DD-YYYY HH:mm"), isAmountDisabled: true,isMarkUpAmountDisabled:true, isAmountPercentDisabled: false, fromCurrency: defaultCurrency, toCurrency: this.selectedCurrency,chargesType:"DIRECT" };
      this.directData = [newRow, ...this.directData];
      this.gridApiDirect.setRowData(this.directData);
    } else if (type == "SLAB") {
      console.log("Slab " + Number(this.maxBalance));
      this.slabData = [];
      const newRow = { symbol: this.selectedCurrencySymbol, currencyName: this.selectedCurrencyName, country: this.selectedCountry, exchangeRate: 0.0, offeredRate: 0.0, fromAmount: 1, toAmount: Number(this.maxBalance), markUp: 0.0, markUpType: "PERCENTAGE", markUpPercentage: 0, effectiveDate: moment().format("MM-DD-YYYY HH:mm"), isAmountDisabled: true,isMarkUpAmountDisabled:true, isAmountPercentDisabled: false, fromCurrency: defaultCurrency, toCurrency: this.selectedCurrency,chargesType:"SLAB"  };

      this.slabData = [newRow, ...this.slabData];
      console.log(newRow);
      console.log(this.slabData);
      this.gridApiSlab.setRowData(this.slabData);
    }


    console.log(this.slabData);
    console.log(this.directData);

  }


  addRow() {
    const newRow = { symbol: this.selectedCurrencySymbol, currencyName: this.selectedCurrencyName, country: this.selectedCountry, exchangeRate: 0.0, offeredRate: 0.0, fromAmount: 1, toAmount: 0, markUp: 0.0, markUpType: "PERCENTAGE", markUpPercentage: 0, effectiveDate: moment().format("MM-DD-YYYY HH:mm"), isAmountDisabled: false,isMarkUpAmountDisabled:true, isAmountPercentDisabled: false, fromCurrency: defaultCurrency, toCurrency: this.selectedCurrency,chargesType:"SLAB" };
    console.log("ROW: "+newRow);
    this.slabData = [newRow, ...this.slabData];
    console.log(this.slabData);
    
    this.gridApiSlab.setRowData(this.slabData);
  }


  reviewSlab(event:any) {
    event.target.blur()
    this.uuid = "";
    this.oldSlabs = [];
    this.newSlabs = [];
    this.showOldSlab = false;
    this.showNewSlab = false;
    if (this.savedSlabData.length == 0) {
      this.alertService.errorAlertWithMessage("No slabs for review");
      return;
    } else {
      for (let i: number = 0; i < this.savedSlabData.length; i++) {
        if (this.savedSlabData[i].chargesStatus == "PENDING") {
          this.newSlabs.push(this.savedSlabData[i]);
        } else {
          this.oldSlabs.push(this.savedSlabData[i]);
        }
      }
      if (this.oldSlabs.length == 0) {
        this.showOldSlab = false;
      } else {
        this.showOldSlab = true;
      }

      if (this.newSlabs.length == 0) {
        this.showNewSlab = false;
        this.alertService.errorAlertWithMessage("Nothing to Review");
      } else {
        for (let i: number = 0; i < this.newSlabs.length; i++) {
          this.uuid = this.newSlabs[i].uuid;
          break;
        }
        this.showNewSlab = true;
        this.reviewExchangeModal.open();
      }
    }

  }

  isNumber(input: any) {
    var pattern = /^[0-9]+$/;
    return pattern.test(input);
  }


  cloneSavedData() {
    this.cloneData = [];
    this.cloneFinalData = [];
    this.directData = [];
    this.slabData = [];
    this.selectedDirect = false;
    this.selectedSlab = false;
    this.saveButtonVisible = false;
    this.addSlabPermission = false;
    this.selectedClone = false;
    this.showType =false;
    this.testData = [];
    this.editExchangeSlabForm.controls.type.setValue(null);
    if(this.maxBalance == null){
      this.alertService.errorAlertWithMessage(this.selectedCountry+" country is not mapped with the Cross Border Product");
      return;
    }


    if (this.savedSlabData.length != 0) {
      for (let i: number = 0; i < this.savedSlabData.length; i++) {
        if (this.savedSlabData[i].chargesStatus == "PENDING") {
          this.alertService.errorAlertWithMessage("You cannot clone slab because the previous slabs are still in pending");
          this.selectedClone = false;
          return;
        }
      }
      // this.selectedClone = true;
      this.saveButtonVisible = true;
      this.cloneData = JSON.parse(JSON.stringify(this.savedSlabData));
      this.cloneFinalData = this.cloneData.filter((_: any) => {
        console.log("DEMO");

        if (_.chargesType == "DIRECT") {
          this.selectedCloneType = "DIRECT";
        } else {
          this.selectedCloneType = "SLAB";
        }
        console.log("Compare data");
        console.log(_);
        // console.log(this.testData);
        // console.log(this.slabTypeData);
        // console.log("Compare data");
        return _.chargesStatus == "ACTIVE"
      }).map((_: any) => {
        _.effectiveUpdatedDate = moment().format("MM-DD-YYYY HH:mm");
        _.isAmountDisabled = true;
        if(_.markUpType == "FLAT"){
          _.isMarkUpAmountDisabled =false;
          _.isAmountPercentDisabled = true;
        }else{
          _.isMarkUpAmountDisabled =true;
          _.isAmountPercentDisabled = false;
        }
        delete _.status;
        delete _.approvedBy;
        delete _.approvedOn;
        delete _.createdBy;
        delete _.approvedDate;
        delete _.createDate;
        delete _.createdOn;
        delete _.effectiveUpdatedDate;
        delete _.effectiveUpdateDate;
        delete _.effectiveDate;
        delete _.toCurrencySymbol;
        delete _.toCurrencyName;
        delete _.selectedCurrency;
        delete _.effectiveDate;
        let markUpData = _.markUpAmount;
        _.markUp = markUpData;
        delete _.markUpAmount;
        _.country = this.selectedCountry;
        _.symbol = this.selectedCurrencySymbol;
        _.effectiveDate = moment().format("MM-DD-YYYY HH:mm");
        _.currencyName = this.selectedCurrencyName;
        console.log(_.markUpPercentage);
        return _;
      });
      console.log("Data type clone: " + this.selectedCloneType);


      if (this.selectedCloneType == "DIRECT") {
        console.log("Inside DIRECT");
        this.saveButtonVisible = true;
        this.selectedDirect = true;
        this.directData = [];
        this.directData = this.cloneFinalData;
        this.showAddDirectSlabButton = false;
      } else if (this.selectedCloneType == "SLAB") {
        console.log("Inside SLAB");
        this.saveButtonVisible = true;
        this.selectedSlab = true;
        this.slabData = [];
        this.slabData = this.cloneFinalData;
      }
      console.log(this.selectedCloneType);
      console.log(this.slabData);
      console.log(this.directData);
      this.editExchangeSlabForm.controls.type.setValue(this.selectedCloneType);
    } else {
      this.alertService.errorAlertWithMessage("No slabs to be clone");
    }
  }

  updateStatus() {
    Swal.fire({
      title: "Are you sure ?",
      text: "Please note the users(agent, subagent, customers) will not be able to make transactions for this currency",
      confirmButtonText: '<span id="confirm-button-text">Confirm</span>',
      cancelButtonText: '<span id="confirm-button-text">Cancel</span>',
      showCancelButton: true,
      reverseButtons: false,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#7987a1',
      customClass: {
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom'
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Confirm");
        this.slabData = [];
        this.directData = [];
        this.selectedDirect = false;
        this.selectedSlab = false;
        this.selectedType = "";
        this.showType = false;
      } else {
        console.log("Cancel");
      }
    });
  }

  cancelButton() {
    this.router.navigateByUrl('/exchangeRates');
  }

  statusChangeForSlab(status: any) {
    if (this.slabRemarks == "" || this.slabRemarks == undefined) {
      this.alertService.toastWarringMessageAlertWithMessage("Please enter the remark");
      return;
    }
    console.log(status);
    console.log(this.slabRemarks)
    console.log(this.uuid);

    let requestForm = {
      "uuid": this.uuid,
      "chargesStatus": status,
      "remarks": this.slabRemarks,
    }

    this.exchangeService.reviewExchangeRateSlab(requestForm).subscribe((response: any) => {
      console.log(response);
      if (response.response.status == 200) {
        this.reviewExchangeModal.close();
        Swal.fire('Status Change successfully', '', 'success');
        this.exchangeService.getExchangeSlabByCurrency(this.selectedCurrency).subscribe((response: any) => {
          console.log(response);
          if (response.response.data.length == 0) {
            this.showSavedDataTable = false;
          } else {
            this.showSavedDataTable = true;
            this.savedSlabData = response.response.data;
          }
        })
      } else {
        Swal.fire("Error while changing the status", '', 'error');
      }
    })
  }

clearData(){
     this.directData = [];
    this.slabData = [];
    this.selectedDirect = false;
    this.selectedSlab = false;
    this.saveButtonVisible = false;
       this.saveButtonVisible = true;
      this.selectedDirect = true;
      this.directTypeData = new TypeDataTable;
      this.directTypeData.symbol = this.selectedCurrency;
      this.directTypeData.currencyName = this.selectedCurrencyName;
      this.directTypeData.country = this.selectedCountry;
      this.directTypeData.fromCurrency = defaultCurrency;
      this.directTypeData.toCurrency = this.selectedCurrency;
      this.directTypeData.chargesType = this.selectedType;
      this.directTypeData.exchangeRate = 0.0;
      this.directTypeData.offeredRate = 0.0;
      this.directTypeData.fromAmount = 1;
      this.directTypeData.toAmount = Number(this.maxBalance);
      this.directTypeData.markUp = 0;
      this.directTypeData.markUpType = "PERCENTAGE";
      this.directTypeData.markUpPercentage = 0;
      this.directTypeData.isAmountDisabled = true;
      this.directTypeData.isAmountPercentDisabled = false;
      this.directTypeData.effectiveDate = moment().format("MM-DD-YYYY HH:mm");
      this.directData.push(this.directTypeData);
      // this.gridApiDirect.setRowData(this.directData);
      console.log(this.directData);
       this.saveButtonVisible = true;
      this.selectedSlab = true;
      this.slabTypeData = new TypeDataTable;
      this.slabTypeData.symbol = this.selectedCurrency;
      this.slabTypeData.currencyName = this.selectedCurrencyName;
      this.slabTypeData.country = this.selectedCountry;
      this.slabTypeData.fromCurrency = defaultCurrency;
      this.slabTypeData.toCurrency = this.selectedCurrency;
      this.slabTypeData.chargesType = this.selectedType;
      this.slabTypeData.exchangeRate = 0.0;
      this.slabTypeData.offeredRate = 0.0;
      this.slabTypeData.fromAmount = 1;
      this.slabTypeData.toAmount = Number(this.maxBalance);
      this.slabTypeData.markUp = 0;
      this.slabTypeData.markUpType = "PERCENTAGE";
      this.slabTypeData.markUpPercentage = 0;
      this.slabTypeData.isAmountDisabled = true;
      this.slabTypeData.isAmountPercentDisabled = false;
      this.slabTypeData.effectiveDate = moment().format("MM-DD-YYYY HH:mm");
      this.slabData.push(this.slabTypeData);
      // this.gridApiSlab.setRowData(this.slabData);
    }


  

}
